/* eslint-disable max-len */
import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatHeader2NewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.5 3.75C4.05228 3.75 4.5 4.19772 4.5 4.75V11H12V4.75C12 4.19772 12.4477 3.75 13 3.75C13.5523 3.75 14 4.19772 14 4.75V12V19.25C14 19.8023 13.5523 20.25 13 20.25C12.4477 20.25 12 19.8023 12 19.25V13H4.5V19.25C4.5 19.8023 4.05228 20.25 3.5 20.25C2.94772 20.25 2.5 19.8023 2.5 19.25V4.75C2.5 4.19772 2.94772 3.75 3.5 3.75Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.6094 14.2441C15.6094 13.1395 16.5048 12.2441 17.6094 12.2441H19.6094C20.714 12.2441 21.6094 13.1395 21.6094 14.2441V15.1737C21.6094 15.8424 21.2752 16.4669 20.7188 16.8378L18.6094 18.2441H20.6094C21.1617 18.2441 21.6094 18.6918 21.6094 19.2441C21.6094 19.7964 21.1617 20.2441 20.6094 20.2441H16.9427C16.2064 20.2441 15.6094 19.6471 15.6094 18.9107C15.6094 18.4911 15.807 18.0959 16.1427 17.8441L19.6094 15.2441V14.2441H17.6094C17.6094 14.7964 17.1617 15.2441 16.6094 15.2441C16.0571 15.2441 15.6094 14.7964 15.6094 14.2441Z'
            fill='currentColor'
        />
    </svg>
));
